import React, { useState, useEffect } from 'react';

function LabPopUpModal({ show, onClose, onSubmit, defaultValue, onImageChange, imageCategory,isUploading}) {
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (defaultValue && imageCategory) {
      setDescription(defaultValue.description || '');
    } else {
      setDescription('');
    }
  }, [defaultValue]);

  const handleSubmit = () => {
    const data = {description, imageCategory};
    onSubmit(data);
  };

  if (!show) return null;

  const styles = {
    modal: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      zIndex: 1000,
      width: '400px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 999,
    },
    inputGroup: {
      marginBottom: '15px',
    },
    label: {
      display: 'block',
      marginBottom: '5px',
      fontWeight: 'bold',
    },
    input: {
      width: '100%',
      padding: '8px',
      borderRadius: '4px',
      border: '1px solid #ccc',
    },
    buttonContainer: {
      textAlign: 'right',
      marginTop: '20px',
    },
    button: {
      padding: '10px 20px',
      backgroundColor: '#007BFF',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
    },
    cancelButton: {
      marginRight: '10px',
      backgroundColor: '#6c757d',
    },
  };

  const renderInput = (label, value, onChange, type = 'text') => (
    <div style={styles.inputGroup}>
      <label style={styles.label}>{label}</label>
      <input
        type={type}
        value={value}
        onChange={onChange}
        style={styles.input}
      />
    </div>
  );

  return (
    <>
      <div style={styles.overlay} onClick={onClose}></div>
      <div style={styles.modal}>
        {renderInput('Description', description, (e) => setDescription(e.target.value))}
        <div style={styles.inputGroup}>
          <label style={styles.label}>Upload Image</label>
          <input type="file" onChange={onImageChange} style={styles.input} />
        </div>
        <div style={styles.buttonContainer}>
          <button
            style={{ ...styles.button, ...styles.cancelButton }}
            onClick={onClose}
          >
            Cancel
          </button>
          <button style={styles.button} onClick={handleSubmit}>
          {isUploading ? "Uploading..." : "Submit"}
          </button>
        </div>
      </div>
    </>
  );
}

export default LabPopUpModal;